import { xor } from 'lodash';
import { DEFAULT_API_CONFIG } from './apiConfig';

const { url, getHeaders } = DEFAULT_API_CONFIG;
const baseRoute = `${url}/qa`;
const rootRoute = `${url}`;

export const getOrderReview = async orderLineId => {
  const url = `${baseRoute}/OrderReview/${orderLineId}`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });
  
  return response.ok ? response?.json() : Promise.reject(response);
};

export const rejectOrderReview = async (orderLineId, reason) => {
  const url = `${baseRoute}/OrderReview/${orderLineId}/Reject`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'POST',
    headers,
    body: JSON.stringify(reason),
  });
  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

export const holdOrderReview = async (orderLineId, model) => {
  const url = `${baseRoute}/OrderReview/${orderLineId}/Hold`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'POST',
    headers,
    body: JSON.stringify(model),
  });
  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

export const completeOrderReview = async (orderLineId, cancelledOrderInfo) => {
  // const url = `${baseRoute}/OrderReview/${orderLineId}/${!!cancelledOrderInfo ? 'CancelReport' : 'Complete'}`;
  const url = `${baseRoute}/OrderReview/${orderLineId}/Complete`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'PUT',
    headers,
    // body: !!cancelledOrderInfo ? JSON.stringify(cancelledOrderInfo) : null
  });
  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

export const inProgressOrderReview = async orderLineId => {
  const url = `${baseRoute}/OrderReview/${orderLineId}/InProgress`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'PUT',
    headers,
  });
  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

export const cancelReportOrderReview = async orderLineVM => {
  const url = `${baseRoute}/OrderReview/${orderLineVM.id}/CancelReport`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'PUT',
    headers,
    body: JSON.stringify(orderLineVM),
  });
  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

export const getNewOrders = async () => {
  const url = `${baseRoute}/NewOrders/`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });
  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

export const saveAnswers = async (answers, image) => {
  const url = `${baseRoute}/OrderReview/SaveAnswers${
    image?.formQaImageId ? '?formImageId=' + image.formQaImageId : ''
  }`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'PUT',
    headers,
    body: JSON.stringify(answers),
  });
  if (response.status === 200 || response.status === 201) {
    return response.json();
  }
  if (response.status === 204) {
    return response.status;
  }
  const e = new Error();
  e.code = response.status;
  e.message = response.statusText;
  throw e;
};

export const getSketches = async orderFormHeaderId => {
  const url = `${baseRoute}/OrderReview/sketch?orderFormHeaderId=${orderFormHeaderId}`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });

  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

export const getCommercialNarrativeRiskTypes = async () => {
  const url = `${rootRoute}/orders/CommercialNarrativeRiskTypes`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });

  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

export const getCommercialNarratives = async riskTypeId => {
  const url = `${rootRoute}/orders/CommercialNarrative/${riskTypeId}`;

  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });

  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

export const getSketch = async sketchId => {
  const url = `${baseRoute}/OrderReview/sketch/${sketchId}`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });

  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

export const updateSketch = async sketch => {
  const url = `${baseRoute}/OrderReview/sketch`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'PUT',
    headers,
    body: JSON.stringify(sketch),
  });

  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

export const saveSketch = async sketch => {
  const url = sketch.formAnswerSketchID
    ? `${baseRoute}/OrderReview/sketch/${sketch.formAnswerSketchID}`
    : `${baseRoute}/OrderReview/sketch`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: sketch.formAnswerSketchID ? 'PUT' : 'POST',
    headers,
    body: JSON.stringify(sketch),
  });

  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

export const completeSketch = async formAnswerSketchID => {
  const url = `${baseRoute}/OrderReview/sketch/${formAnswerSketchID}/complete`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'PUT',
    headers,
  });
  const json = await response;
  return response.ok ? json : Promise.reject(json);
};

export const uploadSketch = async (formAnswerSketchID, base64) => {
  const url = `${baseRoute}/OrderReview/sketch/${formAnswerSketchID}/upload`;
  let headers = getHeaders();

  const response = await fetch(url, {
    method: 'PUT',
    headers,
    body: JSON.stringify(base64.replace('data:image/png;base64,', '')), //:
  });
  const json = await response;
  return response.ok ? json : Promise.reject(json);
};

export const getTapeSketch = async orderFormHeaderId => {
  const url = `${baseRoute}/OrderReview/tapesketch?orderFormHeaderId=${orderFormHeaderId}`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });

  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

export const fetchTapeSketchConfig = async () => {
  const url = `${baseRoute}/OrderReview/tapesketch/config`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });

  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

export const saveTapeSketch = async tapeSketch => {
  const url = tapeSketch.tapeSketchId
    ? `${baseRoute}/OrderReview/tapesketch/${tapeSketch.tapeSketchId}`
    : `${baseRoute}/OrderReview/tapesketch`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: tapeSketch.tapeSketchId ? 'PUT' : 'POST',
    headers,
    body: JSON.stringify(tapeSketch),
  });

  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

export const uploadTapeSketch = async (tapeSketchId, base64) => {
  const url = `${baseRoute}/OrderReview/tapesketch/${tapeSketchId}/upload`;
  let headers = getHeaders();

  const response = await fetch(url, {
    method: 'PUT',
    headers,
    body: JSON.stringify(base64.replace('data:image/jpeg;base64,', '')),
  });
  const json = await response;
  return response.ok ? json : Promise.reject(json);
};

export const completeTapeSketch = async tapeSketchId => {
  const url = `${baseRoute}/OrderReview/tapesketch/${tapeSketchId}/complete`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'PUT',
    headers,
  });
  const json = await response;
  return response.ok ? json : Promise.reject(json);
};

export const createOrderPDFReport = async (orderLineId, valuationOverride = false) => {
  const url = `${baseRoute}/Orders/PDFReport/${orderLineId}?completeWithoutCalc=${valuationOverride}`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });
  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

export const getOrderPDFReportHTML = async orderLineId => {
  const url = `${baseRoute}/Orders/PDFReportHTML/${orderLineId}`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });
  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

export const getValuation = async orderLineId => {
  const url = `${baseRoute}/Orders/Valuation/${orderLineId}`; //TBD
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });
  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

export const getQaOrders = async (orderLineStatusLookupIds = []) => {
  let url = `${baseRoute}/orders`;

  if (orderLineStatusLookupIds.length !== null) {
    url += `?orderLineStatusLookupIds=${JSON.stringify(orderLineStatusLookupIds).replace(/[\[\]']+/g, '')}`;
  }

  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });
  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

export const updateFormDefinitionImage = async image => {
  const url = `${baseRoute}/FormDefinitionImage`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'PUT',
    headers,
    body: JSON.stringify(image),
  });
  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

export const updateCancelReportDetails = async orderLine => {
  const url = `${baseRoute}/OrderReview/${orderLine.id}/UpdateCancelReportDetails`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'PUT',
    headers,
    body: JSON.stringify(orderLine),
  });
  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

export const removeAnswers = async formDefinitions => {
  const url = `${baseRoute}/OrderReview/RemoveAnswers/`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'DELETE',
    headers,
    body: JSON.stringify(formDefinitions),
  });
  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

export const processE2ValueLevel1 = async orderLineId => {
  const url = `${baseRoute}/ProcessE2Value/${orderLineId}`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'POST',
    headers,
  });

  const json = await response?.json();
  return response.ok ? json : Promise.reject(json);
};

export const processE2ValueLevel2 = async orderLineId => {
  const url = `${baseRoute}/ProcessE2ValueLevel2/${orderLineId}`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'POST',
    headers,
  });

  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

export const processProntoAdjustment = async orderLineId => {
  const url = `${baseRoute}/ProcessProntoAdjustment/${orderLineId}`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'POST',
    headers,
  });
  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

export const processCoreLogicLevel1 = async orderLineId => {
  const url = `${baseRoute}/ProcessCoreLogic/${orderLineId}`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'POST',
    headers,
  });
  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

export const processCoreLogicLevel2 = async orderLineId => {
  const url = `${baseRoute}/ProcessCoreLogicLevel2/${orderLineId}`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'POST',
    headers,
  });
  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

export const processIso360 = async orderLineId => {
  const url = `${baseRoute}/ProcessIso360/${orderLineId}`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'POST',
    headers,
  });
  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

export const updateOrderLineServices = async orderLineServices => {
  const url = `${baseRoute}/OrderLineServices`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'PUT',
    headers,
    body: JSON.stringify(orderLineServices),
  });

  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

export const updateOrderLineDetails = async orderLineDetails => {
  const url = `${baseRoute}/OrderLineDetails`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'PUT',
    headers,
    body: JSON.stringify(orderLineDetails),
  });

  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

// functions from old OrderReviewService
// passing in `insuredPhone` because it does not exist in the db and we have to get it from somewhere else
export const getData = async (orderLineId, insuredPhone) => {

    let data = await getOrderReview(orderLineId);

    data = prepareData(data, orderLineId, insuredPhone);

    return data;

};

const setAsInProgress = orderLineId => {
  inProgressOrderReview(orderLineId)
    .then(data => {
      // console.log("Order Review is now 'In Progress'");
    })
    .catch(error => console.log(error));
};

export const prepareData = (data, orderLineId, { insuredPhone = null, policyNumber = null } = {}) => {
  data.orderLineId = orderLineId;
  data.formHeaders.sort(function(a, b) {
    if (a.name === 'Residential Primary' && b.name !== 'Residential Primary') {
      return 1;
    }
    if (a.name !== 'Residential Primary' && b.name === 'Residential Primary') {
      return -1;
    }
    return 0;
  });

  // set order info form definitions
  let orderInfoFormDefinitions = [];
  let duplicateFormHeaders = [];

  data.formHeaders.forEach((formHeader, index) => {
    formHeader.index = index;

    // If a form header exists multiple times, add a duplicateOrder property to its object so it can
    // be differentiated by 'name + order' in the left side nav. This is a workaround until we have a better option in place.
    if (duplicateFormHeaders[formHeader.name]) {
      duplicateFormHeaders[formHeader.name] = duplicateFormHeaders[formHeader.name] + 1;
      formHeader.duplicateOrder = duplicateFormHeaders[formHeader.name];
    } else {
      const hasDuplicates = data.formHeaders.filter(fh => fh.name === formHeader.name);
      if (hasDuplicates.length > 1) {
        duplicateFormHeaders[formHeader.name] = 1;
        formHeader.duplicateOrder = 1;
      }
    }


    if (formHeader.formDefinitions) {
      orderInfoFormDefinitions = orderInfoFormDefinitions.concat(
        formHeader.formDefinitions.filter(
          fd =>
            fd.questionCategoryName === 'Order Info' &&
            fd.formHeaderId !== 240 &&
            orderInfoFormDefinitions.find(oifd => oifd.questionId === fd.questionId) === undefined,
        ),
      );
    } else {
      formHeader.formDefinitions = [];
    }
  });

  // remove certain order info form definitions so they are not displayed
  orderInfoFormDefinitions = orderInfoFormDefinitions.filter(fd => !fd.questionValue.includes('Mailing'));
  data.orderInfoFormDefinitions = orderInfoFormDefinitions;

  // if `insuredPhone` is passed in, generate a form definition template for it so that it shows up in the sidebar
  if (insuredPhone) {
    const insuredPhoneInfoFormDefinition = {
      formDefinitionId: 'insured-phone',
      answerType: 'Number of items',
      questionValue: 'Insured Phone #',
      questionShortName: 'Insured Phone #',
      questionDescription: null,
      questionCategoryId: 2,
      questionCategoryName: 'Order Info',
      dataSources: ['Order Ticket Data'],
      context: 'Pre-Order',
      answers: [
        {
          default: false,
          text: insuredPhone,
          type: 'Number of items',
          reviewed: false,
          images: [],
        },
      ],
      answerTriggers: [],
    };

    // if `insured name` exists, place the insured phone directly after it
    const insuredNameIndex = data.orderInfoFormDefinitions.findIndex(oifd => oifd.questionValue === 'Insured Name');

    if (insuredNameIndex !== -1) {
      data.orderInfoFormDefinitions = data.orderInfoFormDefinitions
        .slice(0, insuredNameIndex + 1)
        .concat(insuredPhoneInfoFormDefinition)
        .concat(...data.orderInfoFormDefinitions.slice(insuredNameIndex + 1));
    }
  }

  // if `policyNumber` is passed in, generate a form definition template for it so that it shows up in the sidebar
  if (policyNumber) {
    const policyNumberFormDefinition = {
      formDefinitionId: 'policy-number',
      answerType: 'Number of items',
      questionValue: 'Policy Number',
      questionShortName: 'Policy Number',
      questionDescription: null,
      questionCategoryId: 2,
      questionCategoryName: 'Order Info',
      dataSources: ['Order Ticket Data'],
      context: 'Pre-Order',
      answers: [
        {
          default: false,
          text: policyNumber,
          type: 'Number of items',
          reviewed: false,
          images: [],
        },
      ],
      answerTriggers: [],
    };

    // if `insured name` exists, place the insured phone directly after it
    const orderTicketNumberIndex = data.orderInfoFormDefinitions.findIndex(
      oifd => oifd.questionValue === 'Order Ticket Number',
    );

    if (orderTicketNumberIndex !== -1) {
      data.orderInfoFormDefinitions = data.orderInfoFormDefinitions
        .slice(0, orderTicketNumberIndex + 1)
        .concat(policyNumberFormDefinition)
        .concat(...data.orderInfoFormDefinitions.slice(orderTicketNumberIndex + 1));
    }
  }
  data.orderInfoFormDefinitions = data.orderInfoFormDefinitions.sort((a,b) => a.sequence - b.sequence);

  // check service status and mark as in progress if not already
  if (data.serviceStatus === 'ASSIGNED' || data.serviceStatus === 'REASSIGNED') {
    setAsInProgress(orderLineId);
  }

  return data;
};

export async function fetchLayerData() {
  const url = `${baseRoute}/orderreview/sketch/config`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });

  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
}

export const updateFormImage = async (formImageId, base64) => {
  const url = `${baseRoute}/OrderReview/FormImage/${formImageId}/Update`;
  let headers = getHeaders();

  const response = await fetch(url, {
    method: 'PUT',
    headers,
    body: JSON.stringify(base64.replace('data:image/png;base64,', '')),
  });
  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

export const createFormImage = async (formImageId, base64) => {
  const url = `${baseRoute}/OrderReview/FormImage/${formImageId}/Create`;
  let headers = getHeaders();

  const response = await fetch(url, {
    method: 'PUT',
    headers,
    body: JSON.stringify(base64.replace('data:image/png;base64,', '')),
  });
  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

export const getReportAttachments = async orderLineId => {
  const url = `${baseRoute}/OrderReview/ReportAttachment/${orderLineId}`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });

  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

export const removeReportAttachment = async reportAttachmentId => {
  const url = `${baseRoute}/OrderReview/ReportAttachment/${reportAttachmentId}`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'DELETE',
    headers,
  });

  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

export const uploadReportAttachment = async (file, orderLineId) => {
  const url = `${baseRoute}/OrderReview/ReportAttachment/${orderLineId}`;
  let headers = getHeaders();
  delete headers['Content-Type'];

  const formData = new FormData();
  formData.append('file', file);

  const response = await fetch(url, {
    method: 'POST',
    body: formData,
    headers,
  });
  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

export const getHazardHubData = async orderLineId => {
  const url = `${baseRoute}/HazardHubData/${orderLineId}`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });

  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

export const getVexcelPropertyData = async orderLineId => {
  const url = `${baseRoute}/VexcelPropertyData/${orderLineId}`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });

  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

export const getRemoteInvisionData = async orderLineId => {
  const url = `${baseRoute}/RemoteInvisionData/${orderLineId}`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });

  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

export const getValuationHistory = async orderLineId => {
  const url = `${baseRoute}/ValuationHistory/${orderLineId}`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });

  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

export const addFormHeader = async (orderLineId, formHeaderId) => {
  const url = `${baseRoute}/${orderLineId}/AddFormHeader`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'POST',
    headers,
    body: JSON.stringify(formHeaderId),
  });

  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};
